import { Component, EventEmitter, Input, Output } from '@angular/core';

/** Which panel of a student is open. Only the first two are built so far. */
export type TStudentTab =
  'progress' | 'exams' | 'planner' | 'videos' | 'weekly-report' | 'meeting-notes' | 'tasks' | 'messages';

interface IStudentTab {
  key: TStudentTab;
  labelKey: string;
  icon: string;
  /** Tabs whose screens have not been built yet are shown but cannot be opened. */
  disabled?: boolean;
}

@Component({
  selector: 'coach-student-tabs',
  templateUrl: './student-tabs.component.html',
  styleUrl: './student-tabs.component.scss',
})
export class StudentTabsComponent {
  @Input() activeTab: TStudentTab = 'progress';
  /** Counter shown next to the planner tab, e.g. "3/6". */
  @Input() plannerProgress?: string | null;
  /** Same idea for the task tab, e.g. "3/5". */
  @Input() taskProgress?: string | null;
  /** Messages waiting to be read; hidden at zero. */
  @Input() unreadMessages = 0;

  @Output() tabChanged = new EventEmitter<TStudentTab>();

  tabs: IStudentTab[] = [
    {key: 'progress', labelKey: 'students.tabs.progress', icon: 'bi-signpost-split'},
    {key: 'exams', labelKey: 'students.tabs.exams', icon: 'bi-bar-chart', disabled: true},
    {key: 'planner', labelKey: 'students.tabs.planner', icon: 'bi-calendar-week'},
    {key: 'videos', labelKey: 'students.tabs.videos', icon: 'bi-play-btn'},
    {key: 'weekly-report', labelKey: 'students.tabs.weekly_report', icon: 'bi-file-earmark-text'},
    {key: 'meeting-notes', labelKey: 'students.tabs.meeting_notes', icon: 'bi-journal-text'},
    {key: 'tasks', labelKey: 'students.tabs.tasks', icon: 'bi-clipboard-check'},
    {key: 'messages', labelKey: 'students.tabs.messages', icon: 'bi-chat-dots'},
  ];

  select(tab: IStudentTab) {
    if (tab.disabled || tab.key === this.activeTab) {
      return;
    }

    this.tabChanged.emit(tab.key);
  }
}
